import BaseComponent from 'scripts/BaseComponent.js';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default class ProductTickerCarousel extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      splideContainer: '.js-imageTickerSwiper',
    };

    this.dom = {
      $component: component,
      $splideContainer: this.$get(this.refs.splideContainer),
    };

    this.state = {
      splide: null,
      imageLoadedClass: 'image-loaded',
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state } = this;

    state.splide = new Splide(dom.$splideContainer, {
      type: 'loop',
      drag: 'free',
      autoWidth: true,
      arrows: false,
      pagination: false,
      lazyLoad: 'sequential',
      gap: '20px',
      autoScroll: {
        speed: 1,
        pauseOnHover: false,
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          gap: '45px',
        },
      },
    });

    state.splide.on('lazyload:loaded', this.imageLoaded.bind(this));
    state.splide.mount({ AutoScroll });
  }

  imageLoaded(img) {
    const { state } = this;
    img.classList.add(state.imageLoadedClass);
  }
}
